// AUTO-GENERATED by scripts/gen-corpus-tops.ts — do not edit by hand.
export const TRANSLATION_KEYWORDS_TH_TOP: string[] = [
  "แปลเอกสารรับรองกงสุล",
  "รับรองคำแปล กรมการกงสุล แจ้งวัฒนะ",
  "แปลเอกสารราชการ ราคา 2026",
  "แปลเอกสารด่วน 1 วัน",
  "แปลเอกสารยื่นอำเภอ จดทะเบียนสมรส",
  "แปลเอกสารยื่น ตม. ต่อวีซ่า",
  "แปลเอกสารยื่นกรมที่ดิน โอนคอนโด",
  "แปลเอกสารบริษัท จดทะเบียน DBD",
  "Apostille 2026 ต้องแปลไหม",
  "ค่าธรรมเนียมนิติกรณ์ 200 400 บาท",
  "แปลเอกสารภาษาอังกฤษ",
  "แปลอังกฤษเป็นไทย รับรองกงสุล",
  "นักแปลภาษาอังกฤษ รับรองเอกสาร",
  "แปลเอกสารภาษาจีน",
  "แปลจีนเป็นไทย รับรองกงสุล",
  "นักแปลภาษาจีน รับรองเอกสาร",
  "แปลเอกสารภาษาญี่ปุ่น",
  "แปลญี่ปุ่นเป็นไทย รับรองกงสุล",
  "นักแปลภาษาญี่ปุ่น รับรองเอกสาร",
  "แปลเอกสารภาษาเกาหลี",
  "แปลเกาหลีเป็นไทย รับรองกงสุล",
  "นักแปลภาษาเกาหลี รับรองเอกสาร",
  "แปลเอกสารภาษาเยอรมัน",
  "แปลเยอรมันเป็นไทย รับรองกงสุล",
  "นักแปลภาษาเยอรมัน รับรองเอกสาร",
  "แปลเอกสารภาษาฝรั่งเศส",
  "แปลฝรั่งเศสเป็นไทย รับรองกงสุล",
  "นักแปลภาษาฝรั่งเศส รับรองเอกสาร",
  "แปลเอกสารภาษาสเปน",
  "แปลสเปนเป็นไทย รับรองกงสุล",
  "นักแปลภาษาสเปน รับรองเอกสาร",
  "แปลเอกสารภาษารัสเซีย",
  "แปลรัสเซียเป็นไทย รับรองกงสุล",
  "นักแปลภาษารัสเซีย รับรองเอกสาร",
  "แปลเอกสารภาษาอิตาลี",
  "แปลอิตาลีเป็นไทย รับรองกงสุล",
  "นักแปลภาษาอิตาลี รับรองเอกสาร",
  "แปลเอกสารภาษาอาหรับ",
  "แปลอาหรับเป็นไทย รับรองกงสุล",
  "นักแปลภาษาอาหรับ รับรองเอกสาร",
  "แปลเอกสารภาษาเวียดนาม",
  "แปลเวียดนามเป็นไทย รับรองกงสุล",
  "นักแปลภาษาเวียดนาม รับรองเอกสาร",
  "แปลเอกสารภาษาพม่า",
  "แปลพม่าเป็นไทย รับรองกงสุล",
  "นักแปลภาษาพม่า รับรองเอกสาร",
  "แปลเอกสารภาษาลาว",
  "แปลลาวเป็นไทย รับรองกงสุล",
  "นักแปลภาษาลาว รับรองเอกสาร",
  "แปลเอกสารภาษาเขมร",
  "แปลเขมรเป็นไทย รับรองกงสุล",
  "นักแปลภาษาเขมร รับรองเอกสาร",
  "แปลเอกสารภาษาอินโดนีเซีย",
  "แปลอินโดนีเซียเป็นไทย รับรองกงสุล",
  "นักแปลภาษาอินโดนีเซีย รับรองเอกสาร",
  "แปลเอกสารภาษามาเลย์",
  "แปลมาเลย์เป็นไทย รับรองกงสุล",
  "นักแปลภาษามาเลย์ รับรองเอกสาร",
  "แปลเอกสารภาษาตากาล็อก",
  "แปลตากาล็อกเป็นไทย รับรองกงสุล",
  "นักแปลภาษาตากาล็อก รับรองเอกสาร",
  "แปลเอกสารภาษาดัตช์",
  "แปลดัตช์เป็นไทย รับรองกงสุล",
  "นักแปลภาษาดัตช์ รับรองเอกสาร",
  "แปลเอกสารภาษาสวีเดน",
  "แปลสวีเดนเป็นไทย รับรองกงสุล",
  "นักแปลภาษาสวีเดน รับรองเอกสาร",
  "แปลเอกสารภาษาเดนมาร์ก",
  "แปลเดนมาร์กเป็นไทย รับรองกงสุล",
  "นักแปลภาษาเดนมาร์ก รับรองเอกสาร",
  "แปลเอกสารภาษาฟินแลนด์",
  "แปลฟินแลนด์เป็นไทย รับรองกงสุล",
  "นักแปลภาษาฟินแลนด์ รับรองเอกสาร",
  "แปลเอกสารภาษานอร์เวย์",
  "แปลนอร์เวย์เป็นไทย รับรองกงสุล",
  "นักแปลภาษานอร์เวย์ รับรองเอกสาร",
  "แปลเอกสารภาษาโปแลนด์",
  "แปลโปแลนด์เป็นไทย รับรองกงสุล",
  "นักแปลภาษาโปแลนด์ รับรองเอกสาร",
  "แปลเอกสารภาษาเช็ก",
  "แปลเช็กเป็นไทย รับรองกงสุล",
  "นักแปลภาษาเช็ก รับรองเอกสาร",
  "แปลเอกสารภาษาโปรตุเกส",
  "แปลโปรตุเกสเป็นไทย รับรองกงสุล",
  "นักแปลภาษาโปรตุเกส รับรองเอกสาร",
  "แปลเอกสารภาษาตุรกี",
  "แปลตุรกีเป็นไทย รับรองกงสุล",
  "นักแปลภาษาตุรกี รับรองเอกสาร",
  "แปลเอกสารภาษาเปอร์เซีย",
  "แปลเปอร์เซียเป็นไทย รับรองกงสุล",
  "นักแปลภาษาเปอร์เซีย รับรองเอกสาร",
  "แปลเอกสารภาษาฮินดี",
  "แปลฮินดีเป็นไทย รับรองกงสุล",
  "นักแปลภาษาฮินดี รับรองเอกสาร",
  "แปลสูติบัตร / ใบเกิด รับรอง",
  "แปลสูติบัตร / ใบเกิด ใช้ในไทย",
  "แปลทะเบียนสมรส / ใบสำคัญการสมรส รับรอง",
  "แปลทะเบียนสมรส / ใบสำคัญการสมรส ใช้ในไทย",
  "แปลใบหย่า / บันทึกข้อตกลงหย่า รับรอง",
  "แปลใบหย่า / บันทึกข้อตกลงหย่า ใช้ในไทย",
  "แปลมรณบัตร รับรอง",
  "แปลมรณบัตร ใช้ในไทย",
  "แปลใบเปลี่ยนชื่อ–สกุล รับรอง",
  "แปลใบเปลี่ยนชื่อ–สกุล ใช้ในไทย",
  "แปลใบรับรองความประพฤติ (Police Clearance) รับรอง",
  "แปลใบรับรองความประพฤติ (Police Clearance) ใช้ในไทย",
  "แปลปริญญาบัตร / ทรานสคริปต์ รับรอง",
  "แปลปริญญาบัตร / ทรานสคริปต์ ใช้ในไทย",
  "แปลใบขับขี่ต่างประเทศ รับรอง",
  "แปลใบขับขี่ต่างประเทศ ใช้ในไทย",
  "แปลหนังสือรับรองบริษัท / DBD รับรอง",
  "แปลหนังสือรับรองบริษัท / DBD ใช้ในไทย",
  "แปลบอจ.5 / บัญชีรายชื่อผู้ถือหุ้น รับรอง",
  "แปลบอจ.5 / บัญชีรายชื่อผู้ถือหุ้น ใช้ในไทย",
  "แปลหนังสือบริคณห์สนธิ / ข้อบังคับบริษัท รับรอง",
  "แปลหนังสือบริคณห์สนธิ / ข้อบังคับบริษัท ใช้ในไทย",
  "แปลงบการเงิน / รายงานผู้สอบบัญชี รับรอง",
  "แปลงบการเงิน / รายงานผู้สอบบัญชี ใช้ในไทย",
  "แปลหนังสือมอบอำนาจ (POA) รับรอง",
  "แปลหนังสือมอบอำนาจ (POA) ใช้ในไทย",
  "แปลสัญญาการค้า / สัญญาจ้าง รับรอง",
  "แปลสัญญาการค้า / สัญญาจ้าง ใช้ในไทย",
  "แปลคำพิพากษา / คำสั่งศาล รับรอง",
  "แปลคำพิพากษา / คำสั่งศาล ใช้ในไทย",
  "แปลพินัยกรรม / เอกสารจัดการมรดก รับรอง",
  "แปลพินัยกรรม / เอกสารจัดการมรดก ใช้ในไทย",
  "แปลใบรับรองแพทย์ / ผลตรวจสุขภาพ รับรอง",
  "แปลใบรับรองแพทย์ / ผลตรวจสุขภาพ ใช้ในไทย",
  "แปลใบรับรองวัคซีน รับรอง",
  "แปลใบรับรองวัคซีน ใช้ในไทย",
  "แปลStatement ธนาคาร / หนังสือรับรองการเงิน รับรอง",
  "แปลStatement ธนาคาร / หนังสือรับรองการเงิน ใช้ในไทย",
  "แปลใบอนุญาตประกอบธุรกิจ / ใบอนุญาตโรงงาน รับรอง",
  "แปลใบอนุญาตประกอบธุรกิจ / ใบอนุญาตโรงงาน ใช้ในไทย",
  "แปลเอกสารสิทธิบัตร เครื่องหมายการค้า รับรอง",
  "แปลเอกสารสิทธิบัตร เครื่องหมายการค้า ใช้ในไทย",
  "แปลใบรับรองมาตรฐาน ISO / ผลทดสอบแล็บ รับรอง",
  "แปลใบรับรองมาตรฐาน ISO / ผลทดสอบแล็บ ใช้ในไทย"
];
export const TRANSLATION_KEYWORDS_EN_TOP: string[] = [
  "certified translation Thailand",
  "MFA legalization Bangkok translation",
  "sworn translation for Thai authorities",
  "apostille translation Thailand 2026",
  "translate documents for Thai marriage registration",
  "translate documents for Thai work permit",
  "English to Thai certified translation",
  "English document legalization Thailand",
  "Chinese to Thai certified translation",
  "Chinese document legalization Thailand",
  "Japanese to Thai certified translation",
  "Japanese document legalization Thailand",
  "Korean to Thai certified translation",
  "Korean document legalization Thailand",
  "German to Thai certified translation",
  "German document legalization Thailand",
  "French to Thai certified translation",
  "French document legalization Thailand",
  "Spanish to Thai certified translation",
  "Spanish document legalization Thailand",
  "Russian to Thai certified translation",
  "Russian document legalization Thailand",
  "Italian to Thai certified translation",
  "Italian document legalization Thailand",
  "Arabic to Thai certified translation",
  "Arabic document legalization Thailand",
  "Vietnamese to Thai certified translation",
  "Vietnamese document legalization Thailand",
  "Myanmar to Thai certified translation",
  "Myanmar document legalization Thailand",
  "Lao to Thai certified translation",
  "Lao document legalization Thailand",
  "Khmer to Thai certified translation",
  "Khmer document legalization Thailand",
  "Indonesian to Thai certified translation",
  "Indonesian document legalization Thailand",
  "Malay to Thai certified translation",
  "Malay document legalization Thailand",
  "Tagalog to Thai certified translation",
  "Tagalog document legalization Thailand",
  "Dutch to Thai certified translation",
  "Dutch document legalization Thailand",
  "Swedish to Thai certified translation",
  "Swedish document legalization Thailand",
  "Danish to Thai certified translation",
  "Danish document legalization Thailand",
  "Finnish to Thai certified translation",
  "Finnish document legalization Thailand",
  "Norwegian to Thai certified translation",
  "Norwegian document legalization Thailand",
  "Polish to Thai certified translation",
  "Polish document legalization Thailand",
  "Czech to Thai certified translation",
  "Czech document legalization Thailand",
  "Portuguese to Thai certified translation",
  "Portuguese document legalization Thailand",
  "Turkish to Thai certified translation",
  "Turkish document legalization Thailand",
  "Persian to Thai certified translation",
  "Persian document legalization Thailand",
  "Hindi to Thai certified translation",
  "Hindi document legalization Thailand",
  "Birth certificate translation Thailand",
  "Marriage certificate translation Thailand",
  "Divorce decree & settlement translation Thailand",
  "Death certificate translation Thailand",
  "Name / surname change certificate translation Thailand",
  "Police clearance certificate translation Thailand",
  "Degree certificate & transcript translation Thailand",
  "Foreign driving licence translation Thailand",
  "Company affidavit (DBD) translation Thailand",
  "Shareholder list (BOJ.5) translation Thailand",
  "MOA & Articles of Association translation Thailand",
  "Financial statements & audit report translation Thailand",
  "Power of attorney translation Thailand",
  "Commercial & employment contracts translation Thailand",
  "Court judgments & orders translation Thailand",
  "Wills & estate documents translation Thailand",
  "Medical certificates & health screening translation Thailand",
  "Vaccination records translation Thailand",
  "Bank statements & financial support letters translation Thailand",
  "Business & factory licences translation Thailand",
  "Patent & trademark filings translation Thailand",
  "ISO certificates & lab test reports translation Thailand"
];
export const TRANSLATION_KEYWORDS_TH_TOTAL = 138;
export const TRANSLATION_KEYWORDS_EN_TOTAL = 84;
export const TRANSLATION_QUESTIONS_TH_TOTAL = 78;
